import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { CONTROL_APP_CONST } from "../../../config/control-app.constant";
import { ErrorService } from "../../../../control-core/services/error.service";
import {
  ISimpleTableConfig,
  SimpleTableConfig
} from "../../../../control-core/shared/simple-table/simple-table.component";
import { NGXLogger } from "ngx-logger";
import { StateService } from '@uirouter/core';
import { IRespuestaConsultaWHR, RespuestaConsultaWHRModel } from "../../../models/whr/warehouse.model";
import { initWaitMe, stopWaitMe, WaitMeOptionModel } from "../../../../control-core/util/waitme.util";
import { DANGER_NOTIFY, notify, SUCCESS_NOTIFY } from "../../../../control-core/util/notify.util";
import { TranslateService } from "@ngx-translate/core";
import Swal from 'sweetalert2'
import { GeparametersService } from "../../../../control-core/services/geparameters.service";
import { tap } from "rxjs/operators";

declare let jquery: any;
declare let $: any;

@Component({
  selector: 'app-consulta-warehouse',
  templateUrl: './consulta-warehouse.component.html'
})
export class ConsultaWarehouseComponent implements OnInit {

  consultaForm: FormGroup;
  consultando: boolean = false;
  simpleTableDataConfig: ISimpleTableConfig;
  estatusGuias: IStatusArray[];
  statusGuia = "";
  ordenPagoSeleccionado: string;
  nWarehouseEnBodega: number;

  titleReempaque: string = '';
  validWhrReempq: RespuestaConsultaWHRModel[] = [];
  listWhrReempq: RespuestaConsultaWHRModel[] = [];

  _CONFIRM_PETICION_LABEL = this._translate.instant('CONFIRM_PETICION_LABEL');
  _YES_LABEL = this._translate.instant('YES_LABEL');
  _NO_LABEL = this._translate.instant('NO_LABEL');
  private _DESPACHADO_LABEL = this._translate.instant('3_DESPACHADO');
  private _EN_BODEGA = this._translate.instant('1_EN_BODEGA');
  private _A_GUIA = this._translate.instant('2_A_GUIA');

  limitPeso: number = 0;
  limitVlrDeclarado: number = 0;
  pesoSobre: number = 0;

  newVlrDeclaroReempaque = {
    vlr_declarado: 0,
    limit_valdec: 0
  };

  objPesoReempaque = {
    peso: 0,
    limit_peso: this.limitPeso
  };

  public _showHijoReempq: boolean = false;
  public _showObsReempq: boolean = false;
  public _newVlrReempaque: number = 0;
  textErrorSelWhrsHijos: string = this._translate.instant('PLEASE_SEL_WHRHIJOS_LABEL');
  _Sobre_Trans: string = this._translate.instant('SOBRE_LABEL');
  _Caja_Trans: string = this._translate.instant('CAJA_LABEL');

  newObservacion?: string = '';

  listWhrDivision: IRespuestaConsultaWHR[] = [];
  whrSelDivision: IRespuestaConsultaWHR;
  showHijoDivision: boolean = false;
  mensajeWhrDivSel: string = '';


  private _ordenPagoModal = '#ordenPagoModal';
  private _newPeticionModal = '#newPeticionModal';
  private _newPeticionDivisionModal = '#newPeticionDivisionModal';


  constructor(private _http: HttpClient,
              private _errorService: ErrorService,
              private _state: StateService,
              private _translate: TranslateService,
              private _parameters: GeparametersService,
              private _logger: NGXLogger) {
    this.consultaForm = new FormGroup({
      numwhr: new FormControl(''),
      numtrack: new FormControl(''),
      ordenpago: new FormControl(''),
    });
    this.nWarehouseEnBodega = 0;
  }

  ngOnInit() {
    this._parameters.state$.subscribe((estado) => {
      if (estado == 'ready') {
        this.limitPeso = this._parameters.getNumval('CTRLBX_LIMIT_PESO_REEMPAQUE');
        this.limitVlrDeclarado = this._parameters.getNumval('CTRLBX_WARNNG_VLR_DECLARADO_REEMPAQUE');
        this.pesoSobre = this._parameters.getNumval('CTRLBX_PESO_SOBRE');

        this.objPesoReempaque.limit_peso = this.limitPeso;
        this.newVlrDeclaroReempaque.limit_valdec = this.limitVlrDeclarado;
      }
    });
    this.consultaWHR();
    this.simpleTableDataConfig = new SimpleTableConfig();
    this.simpleTableDataConfig.columns = [
      {
        label: "",
        name: 'estado',
        options: {
          render: (data) => {
            if (data === "3_DESPACHADO") {
              return '<span class="label label-success text-uppercase">' + this._DESPACHADO_LABEL + '</span>';
            } else if (data === "2_A_GUIA") {
              return '<span class="label label-warning text-uppercase">' + this._A_GUIA + '</span>';
            } else if (data == "1_EN_BODEGA") {
              return '<span class="label bg-blue-boxex text-uppercase">' + this._EN_BODEGA + '</span>';
            }
            return data;
          }
        }
      },
      {
        label: "TRACKING_LABEL",
        name: 'tracking'
      },
      {
        label: "PAQUETE_LABEL",
        name: 'nrowhr',
        options: {
          action: (data) => {
            this._state.go("whrdetalle", {nro_whr: data});
          }
        }
      },
      {
        label: "ORDEN_PAGO_LABEL",
        name: 'ref_ordpago',
        options: {
          action: (data, row: IRespuestaConsultaWHR) => {
            this.ordenPagoSeleccionado = data;
            $('#ordenPagoModal').modal('show');
          }
        }
      },
      {
        label: "GUIA_LABEL",
        name: 'nrogui',
        options: {
          action: (data) => {
            this.statusGuia = data;
            $('#statusGuiaModal').modal('show');
            this.consultaGuia(data);
          }
        }
      },
      {
        label: "CONTENIDO_LABEL",
        name: 'paqdesc'
      }
    ];
  }

  rowSelected(data) {
    this._logger.debug(data);
  }

  consultaWHR() {
    this.consultando = true;
    initWaitMe('#tblResultados');
    this._http.get<RespuestaConsultaWHRModel[]>(`${CONTROL_APP_CONST.API_URL}warehouse`,
        {params: this.consultaForm.value})
        .pipe(tap(resConsulta => {
          resConsulta.forEach(warehouse => {
            warehouse.tracking = (warehouse.tracking == null) ? '' : warehouse.tracking;
            if (warehouse.estado == '1_EN_BODEGA' && warehouse.nrogui !== "")
              this.nWarehouseEnBodega += 1;
          });
        }))
        .subscribe(resConsulta => {
              this.simpleTableDataConfig.data = resConsulta;
              this.consultando = false;
            },
            resError => {
              this._errorService.manejaError(resError);
              this.consultando = false;
            }, () => {
              stopWaitMe('#tblResultados');
            });
  }

  consultaGuia(guia: string) {
    // this.estatusGuias.splice(0, this.estatusGuias.length);
    this._http.get<IStatusGuiaResponse>(`${CONTROL_APP_CONST.CONTROLBOXEX_API_URL}publicguia/${guia}`)
        .subscribe((estatusGuias) => this.estatusGuias = estatusGuias.Estatus)
  }

  onOrdenPagoAnulado(response) {
    if (response.success) {
      $(this._ordenPagoModal).modal('hide');
      this.ordenPagoSeleccionado = '';
      this.consultaWHR();
      setTimeout(() => {
        notify(this._translate.instant(response.msg), SUCCESS_NOTIFY);
      }, 500);
    } else {
      this._errorService.manejaError(response.msg);
    }
  }

  onOrdenPagoComprobado(response) {
    if (response.success) {
      $(this._ordenPagoModal).modal('hide');
      this.ordenPagoSeleccionado = '';
      this.consultaWHR();
      setTimeout(() => {
        notify(this._translate.instant(response.msg), SUCCESS_NOTIFY);
      }, 500);
    } else {
      this._errorService.manejaError(response.msg);
    }
  }

  initSolicitudDiv() {

    this.whrSelDivision = new RespuestaConsultaWHRModel();
    this.newObservacion = '';
    this.listWhrDivision.splice(0, this.listWhrDivision.length);

    this.simpleTableDataConfig.data.forEach((whrs) => {
      if (whrs.nrogui == null && whrs.ref_ordpago == null
          && whrs.estado == '1_EN_BODEGA' && whrs.numpeticiones == 0 && !whrs.has_operacion) {
        this.listWhrDivision.push(whrs);
      }
    });

    if (this.listWhrDivision.length === 0) {

      let message = `<p style="font-size: 15px; text-align: center;">
          <b>No tiene paquetes disponibles para realizar divisiones.</b></p>
          <p style="font-size: 15px; text-align: justify;">
          Este mensaje se presenta porque los paquetes en bodega ya fueron divididos
           o tienen pendiente una solicitud de division.</p>`;

      Swal({
        type: 'error',
        html: message,
        width: 360
      });
    } else {

      this.showHijoDivision = true;

      $(this._newPeticionDivisionModal).modal('show');
    }
  }

  selectWhrDivision(whrSel: IRespuestaConsultaWHR) {
    this.showHijoDivision = false;

    this.mensajeWhrDivSel = this._translate.instant('WHR_SELECT_DIVISION', {whr_sel: whrSel.nrowhr});

    this.whrSelDivision = whrSel;
  }

  createPeticionDiv() {
    let message = '<span style="font-size: 15px">' + this._CONFIRM_PETICION_LABEL + '</span>';

    let optionWait = new WaitMeOptionModel();

    optionWait.effect = 'win8';

    initWaitMe('#newDivPanel', optionWait);

    Swal({
      title: '',
      html: message,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: this._YES_LABEL,
      cancelButtonText: this._NO_LABEL
    }).then((result) => {
      if (result.value) {
        let objectPeticion = {
          listwhrs: [this.whrSelDivision.whr_id],
          observacion: "Solicito la division del warehouse: " + this.whrSelDivision.nrowhr +
          ' - Largo: ' + this.whrSelDivision.largo +
          ' Alto: ' + this.whrSelDivision.alto +
          ' Ancho: ' + this.whrSelDivision.ancho +
          ' - ' + this.whrSelDivision.peso + 'lb'
        };

        objectPeticion.observacion += (this.newObservacion != '') ? "\nObservacion: " + this.newObservacion : '';

        this._http.post(`${CONTROL_APP_CONST.API_URL}registroPeticionDivision`, objectPeticion)
            .subscribe((resp) => {
                  $(this._newPeticionDivisionModal).modal('hide');
                  stopWaitMe('#newDivPanel');
                  notify(this._translate.instant("PETICION_REGISTRADA_LABEL"), SUCCESS_NOTIFY);
                  this.consultaWHR();
                },
                (error) => {
                  stopWaitMe('#newDivPanel');
                  this._errorService.manejaError(error);
                })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        stopWaitMe('#newDivPanel');
      }
    });
  }

  initSolicitud() {

    this.validWhrReempq = [];
    this.listWhrReempq = [];
    this.newObservacion = '';
    this._showHijoReempq = true;
    this._showObsReempq = false;
    this._newVlrReempaque = 0;
    this.objPesoReempaque.peso = 0;
    this.newVlrDeclaroReempaque.vlr_declarado = 0;

    this.simpleTableDataConfig.data.forEach((whrs) => {
      if (whrs.nrogui == null && whrs.ref_ordpago == null
          && whrs.estado == '1_EN_BODEGA' && whrs.numpeticiones == 0 && !whrs.has_operacion) {
        if (whrs.es_documento == '1' || (whrs.alto + whrs.ancho + whrs.largo == 0 && whrs.peso === 1)) {
          whrs.tipo_paq = this._Sobre_Trans;
        }
        else {
          whrs.tipo_paq = this._Caja_Trans;
        }

        this.validWhrReempq.push(whrs);
      }
    });

    if (this.validWhrReempq.length === 0) {

      let message = `<p style="font-size: 15px; text-align: center;">
          <b>No tiene paquetes disponibles para realizar reempaques.</b></p>
          <p style="font-size: 15px; text-align: justify;">
          Este mensaje se presenta porque los paquetes en bodega ya fueron reempacados
           o tienen pendiente una solicitud de reempaque.</p>`;

      Swal({
        type: 'error',
        html: message,
        width: 360
      });
    } else {

      $(this._newPeticionModal).modal('show');
    }
  }

  volverSeleccion() {
    this.newObservacion = '';
    this.titleReempaque = this._translate.instant('DIVIDIR_PAQUETE_LABEL');
    this._showHijoReempq = true;
    this._showObsReempq = false;
    this._newVlrReempaque = 0;
  }

  selectWhrHijosReempq(whrSel: RespuestaConsultaWHRModel, vectorOrigen, vectorDestino, isSuma ?: boolean) {
    let valid = true;

    vectorDestino.forEach((whrs) => {
      if (whrs == whrSel) {
        valid = false;
      }
    });

    if (vectorDestino.length == 0 || valid) {
      if (isSuma) {
        this.objPesoReempaque.peso += whrSel.peso;
        this.newVlrDeclaroReempaque.vlr_declarado += whrSel.valordeclarado;
      } else {
        this.objPesoReempaque.peso -= whrSel.peso;
        this.newVlrDeclaroReempaque.vlr_declarado -= whrSel.valordeclarado;
      }

      vectorDestino.push(whrSel);

      vectorOrigen.forEach((value, index) => {
        if (value == whrSel) {
          vectorOrigen.splice(index, 1);
          return false
        }
      })
    }
  }

  ingresarObservacion() {

    if (this.listWhrReempq.length < 2) {
      notify(this.textErrorSelWhrsHijos, DANGER_NOTIFY);
      return false;
    }

    this._showHijoReempq = false;
    this._showObsReempq = true;
    this.titleReempaque = '';

    let objectPeticion = {
      numwhr: this.listWhrReempq.length,
      peso: this.objPesoReempaque.peso
    };


    let optionWait = new WaitMeOptionModel();

    optionWait.effect = 'win8';

    initWaitMe('#newVaslorReempCard', optionWait);

    this._http.post<any>(`${CONTROL_APP_CONST.API_URL}registroPeticion/calcular`, objectPeticion)
        .subscribe((resp) => {
              this._newVlrReempaque= resp.valor;
            },
            (error) => {
              this._errorService.manejaError(error);
            }, () => {
              stopWaitMe('#newVaslorReempCard');
            });
  }

  createPeticion() {
    let message = '<span style="font-size: 15px">' + this._CONFIRM_PETICION_LABEL + '</span>';

    if (this.newVlrDeclaroReempaque.vlr_declarado > this.limitVlrDeclarado) {
      message = '<span style="font-size: 15px">' + this._translate.instant('ALERT_VLR_DECLARADO_LIMIT_OVER',
          {
            limit_valdec: this.limitVlrDeclarado
          }) + '</span><br><br><br>' + message
    }

    let optionWait = new WaitMeOptionModel();

    optionWait.effect = 'win8';

    initWaitMe('#newReempaquePanel', optionWait);

    Swal({
      title: '',
      html: message,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: this._YES_LABEL,
      cancelButtonText: this._NO_LABEL
    }).then((result) => {
      if (result.value) {

        let objectPeticion = {
          observacion: "Solicito reempacar los warehouses: ",
          listwhrs: []
        };

        let sobres = '';
        let cajas = '';

        this.listWhrReempq.forEach((whr) => {
          objectPeticion.listwhrs.push(whr.whr_id);

          if (whr.es_documento == '1' || (whr.alto + whr.ancho + whr.largo == 0 && whr.peso === 1)) {
            sobres += "\n" + whr.nrowhr + ' - Sobre';
          } else {
            cajas += "\n" + whr.nrowhr + ' - Caja - Largo: ' + whr.largo +
                ' Alto: ' + whr.alto +
                ' Ancho: ' + whr.ancho +
                ' - ' + whr.peso + 'lb';
          }
        });

        objectPeticion.observacion += sobres + cajas;

        objectPeticion.observacion += (this.newObservacion != '') ? " \nObservacion: " + this.newObservacion : '';

        this._http.post(`${CONTROL_APP_CONST.API_URL}registroPeticion`, objectPeticion)
            .subscribe((resp) => {
                  $(this._newPeticionModal).modal('hide');
                  stopWaitMe('#newReempaquePanel');
                  notify(this._translate.instant("PETICION_REGISTRADA_LABEL"), SUCCESS_NOTIFY);
                },
                (error) => {
                  stopWaitMe('#newReempaquePanel');
                  this._errorService.manejaError(error);
                })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        stopWaitMe('#newReempaquePanel');
      }
    });
  }

  ngOnDestroy() {
    $('.modal').modal('hide');
    $('.modal-backdrop').remove();
  }
}

export interface IStatusGuiaResponse {
  Estatus : IStatusArray[];
}
interface IStatusArray {
  nombre: string,
  fecha: string
}


// export interface IStatusGuiaResponse {
//   [Estatus: string]:[fecha: string,nombre: string]
// }



// WEBPACK FOOTER //
// ./src/app/control-app/views/whr/consulta/consulta-warehouse.component.ts